import "core-js/modules/es.function.name.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSelectedAndTodayDate } from 'utils/timezone';
import getBasicDate from 'utils/dates/getBasicDate';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import { TimeZoneField } from 'components/FormFields';
import RadioButtonOption from 'components/RadioButtonOption';
import ShadedCard from 'components/ShadedCard';
import Stack from 'components/Stack';
import FormStack from 'components/FormStack';
import DatePicker from 'components/DatePicker';
import TimePicker from 'components/TimePicker';
export default function UnlockingOptionsPanel(_ref) {
  var _unlockTimezone$value;
  var fields = _ref.fields;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isLocked = fields.isLocked,
    lockingMode = fields.lockingMode,
    unlockDate = fields.unlockDate,
    unlockTime = fields.unlockTime,
    unlockTimezone = fields.unlockTimezone;
  var _getSelectedAndTodayD = getSelectedAndTodayDate(unlockDate.value, unlockTimezone.value),
    zonedUnlockDate = _getSelectedAndTodayD.selectedDate,
    zonedTodayDate = _getSelectedAndTodayD.zonedTodayDate;
  return /*#__PURE__*/React.createElement(ShadedCard, {
    borderRadius: "small",
    px: "m",
    py: "s",
    mt: "s",
    ml: "xl"
  }, /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('section_unlocking_options')
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs",
    mt: "xxs"
  }, /*#__PURE__*/React.createElement(RadioButtonOption, {
    bold: true,
    label: t('section_unlocking_manual'),
    description: t('section_unlocking_manual_info'),
    descriptionType: "subtitle",
    checked: isLocked.value && lockingMode.value === null || lockingMode.value === 'locked',
    onChange: function onChange() {
      return lockingMode.set('locked');
    }
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    bold: true,
    label: t('section_unlocking_progress'),
    description: t('section_unlocking_progress_info'),
    descriptionType: "subtitle",
    checked: lockingMode.value === 'progress',
    onChange: function onChange() {
      return lockingMode.set('progress');
    }
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    bold: true,
    label: t('section_unlocking_time'),
    description: t('section_unlocking_time_info'),
    descriptionType: "subtitle",
    checked: lockingMode.value === 'time',
    onChange: function onChange() {
      return lockingMode.set('time');
    }
  }))), lockingMode.value === 'time' && /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true,
    horizontalLabelWidth: 125
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "xs",
    mt: "xs",
    ml: 30
  }, /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: "".concat(t('property_date'), " *"),
    alert: unlockDate.error
  }, /*#__PURE__*/React.createElement(DatePicker, {
    dateFormat: "dd/MM/yyyy",
    selected: zonedUnlockDate,
    minDate: zonedTodayDate,
    onChange: function onChange(setDate) {
      if (setDate) {
        var scheduledDate = getBasicDate(setDate);
        unlockDate.set(scheduledDate);
      }
    }
  })), /*#__PURE__*/React.createElement(FormField, {
    as: "span",
    label: t('property_time'),
    labelId: "unlock-time-label"
  }, /*#__PURE__*/React.createElement(TimePicker, {
    labelledById: "unlock-time-label",
    onChange: function onChange(newValue) {
      return unlockTime.set(newValue);
    },
    value: unlockTime.value,
    variant: "transparent",
    ml: "-s"
  })), /*#__PURE__*/React.createElement(TimeZoneField, {
    value: (_unlockTimezone$value = unlockTimezone.value) !== null && _unlockTimezone$value !== void 0 ? _unlockTimezone$value : undefined,
    onChange: function onChange(selectedTimezone) {
      unlockTimezone.set(selectedTimezone.name);
    },
    alert: unlockTimezone.error
  }))));
}